import Config from "./config.js";

function splitMulti(str, tokens) {
  var tempChar = tokens[0]; // We can use the first token as a temporary join character
  for (var i = 1; i < tokens.length; i++) {
    str = str.split(tokens[i]).join(tempChar);
  }

  str = str.split(tempChar);
  return str;
}

function getSudomain() {
  let host = window.location.host;
  let split = splitMulti(host, [".", ":"]);
  return split[0];
}

let collection;
if (getSudomain() === "localhost") {
  collection = {
    // "api": "http://localhost:8001/",
    // "ws" : "wss://api.assetvault.co.nz/wss/",
    api: "https://atmcloud-dev.onehub.net/",
    ws: "wss://atmcloud-dev.onehub.net/wss/",
    key: Config.KEY_MAP
  };
} else if (getSudomain() === "dev") {
  collection = {
    api: "https://atmcloud-dev.onehub.net/",
    ws: "wss://atmcloud-dev.onehub.net/wss/",
    key: Config.KEY_MAP_DEV
  };
} else if (getSudomain() === "demo") {
  collection = {
    api: "https://api.assetvault.co.nz/",
    ws: "wss://api.assetvault.co.nz/wss/",
    key: Config.KEY_MAP_DEMO
  };
} else if (getSudomain() === "app") {
  collection = {
    api: "https://api2.assetvault.co.nz/",
    ws: "wss://api2.assetvault.co.nz/wss/",
    key: Config.KEY_MAP_PRODUCTION
  };
} else {
  collection = {
    api: "https://atmcloud-dev.onehub.net/",
    ws: "wss://atmcloud-dev.onehub.net/wss/",
    key: Config.KEY_MAP
  };
}

export default {
  ATM_CLOUD: {
    API: collection.api,
    WS: collection.ws
  },
  GOOGLE_MAP: {
    API:
      "https://maps.googleapis.com/maps/api/js?key=" + collection.key + "&v=3"
  }
};



// WEBPACK FOOTER //
// ./src/App/config/server.js